import React from 'react';
import { PressedMotion } from '@/components/elements/PressedMotion';
import { Button } from '@/components/UI';
import { useTranslationWithLocale } from '@/hooks/useTranslationWithLocale';
import { useSetCookies } from '../../../hooks';
import styles from './CookiesActions.module.scss';

export const CookiesActions: React.FC = () => {
	const choseCookies: (type: 'save' | 'reject' | 'accept' | 'popup') => void =
		useSetCookies();
	const { t } = useTranslationWithLocale('common');

	return (
		<div className={styles['actions']}>
			<PressedMotion
				className={styles['actions__button-motion']}
				pressPower={0.95}
			>
				<Button
					as='button'
					preset='secondary'
					text={t('cookies_saveSettings')}
					onClick={() => choseCookies('save')}
					classes={{
						button: styles['actions__button'],
					}}
				/>
			</PressedMotion>
			<PressedMotion
				className={styles['actions__button-motion']}
				pressPower={0.95}
			>
				<Button
					as='button'
					preset='secondary'
					text={t('cookies_rejectAll')}
					onClick={() => choseCookies('reject')}
					classes={{
						button: styles['actions__button'],
					}}
				/>
			</PressedMotion>
			<PressedMotion
				className={styles['actions__button-motion']}
				pressPower={0.95}
			>
				<Button
					as='button'
					text={t('cookies_acceptAll')}
					onClick={() => {
						choseCookies('accept');
						document.body.style.overflow = '';
					}}
					classes={{
						button: styles['actions__button'],
					}}
				/>
			</PressedMotion>
		</div>
	);
};
